import React, { useImperativeHandle, useState, useRef } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from 'react-transition-group';

import '../../scss/polymer-scss.scss';


const P2Accordion = React.forwardRef(({...props},ref) => {

  const [isExpand, setExpand] = useState(props.defaultOpen ? props.defaultOpen : false);

  const toggleAccordion = () => {
    setExpand(prev => !prev);
  }

  useImperativeHandle(ref, () => {
    return {
      toggle(){
        if(props.onToggle){
          props.onToggle(!isExpand);
        }
        toggleAccordion();
      }
    };
  }, [isExpand, props]);
  const nodeRef = useRef(null);
  
  if(props.displayChildOnly){
    return <>
      {props.children}
    </>
  }
  return (
    <div className={`polymer-basic-accordion ${props.classNames ? props.classNames : ""}`}>
      <div
        role="button"
        className='polymer-basic-accordion__title'
        onClick={(e)=>{
          if(props.onToggle && e.target.tagName !== "INPUT"){
            props.onToggle(!isExpand);
          }
          if(e.target.tagName !== "INPUT"){
            toggleAccordion()
          }
        }}
      >
        <div style={{ flex: 1 }}>
          {/* <p className='m-0 f-medium fw-500 user-select-none'>{props.title}</p> */}
          {props.title}
        </div>
        <div className='polymer-basic-accordion__title-icon' style={{ width: 25, height: 25, position: "relative" }}>
          <svg className={isExpand ? 'active-icon' : 'hide-icon'} style={{ position: "absolute" }} width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='12.5' cy='12.4531' r='12' transform='rotate(-180 12.5 12.4531)' fill='#009AAB' /><path d='M5.5 12.4531H19.5' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' /></svg>
          <svg className={!isExpand ? 'active-icon' : 'hide-icon'} style={{ position: "absolute" }} width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='12.5' cy='12.4531' r='12' transform='rotate(-180 12.5 12.4531)' fill='#009AAB' /><path d='M12.5 5.45312V19.4531' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' /><path d='M5.5 12.4531H19.5' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' /></svg>
        </div>
      </div>
      {isExpand && props.hasDivider &&  
        <div style={{padding: "0 1.5rem"}}>
          <div style={{borderBottom: "1px dashed #0C8188", width: "100%"}}></div>
        </div>
      }
      {/* </div> */}
      <CSSTransition
        in={isExpand}
        timeout={300}
        classNames="polymer-basic-accordion__content"
        unmountOnExit
        nodeRef={nodeRef}
      >
        <div ref={nodeRef}>
          <div className='polymer-basic-accordion__content__child' style={{ padding: "0 1.5rem 1.5rem" }}>
            {props.children}
          </div>
        </div>
      </CSSTransition>
    </div>
  );
});


P2Accordion.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  hasDivider: PropTypes.bool,
  classNames: PropTypes.oneOf([undefined, PropTypes.string]),
  displayChildOnly: PropTypes.bool
}


P2Accordion.defaultProps = {
  title: "THIS IS DEFAULT TITLE",
  children: <><div>THIS IS CHILDREN</div></>,
  defaultOpen: false,
  hasDivider: false,
  displayChildOnly: false
};

export default P2Accordion;